



























































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {PushSubscriberItem} from "@/store/push/subscribers/types";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import PushSubscriberFilter from "@/components/Push/Subscribers/PushSubscriberFilter.vue";
import {dateFilter} from "@/utils/date-util";
import AccountsFilter from "@/components/Settings/Accounts/AccountsFilter.vue";

@Component({
  components: {AccountsFilter, PushSubscriberFilter, ScrollButton},
  filters: {dateFilter}
})
export default class PushSubscribers extends BaseItemsPage<PushSubscriberItem> {
  @Getter("pushSubscribers") subscribers: any;
  @Action("deletePushSubscribers") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private is_show_filter = true;
  private ids: (number | undefined)[] = [];
  private logObject: ActionLog = {};
  currentSort = "id";
  currentSortOrder= "desc";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return ['client_id', 'application', 'create_date', 'detail'];
  }

  getData(): any {
    return this.subscribers;
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete(this.$t('dialog.deletion_in_one_minute').toString());
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Subscribers",
          addititional_info: getTranslatedParams({id: this.$route.params.id, number: this.ids.length})
        }
        const { filter } = this.$refs.filter as any;
        await this.actionDelete({ids: this.ids, filter});
        await this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    }
  }

  onSelect(items: PushSubscriberItem[]): void {
    this.ids = items.filter(i => i.id !== null).map(i => i.id);
  }
}
